import {Injectable, Injector} from '@angular/core';
import {APlatformAppService} from "@shared/models/platform-app-service-base";
import {SharedUIService} from "@core/services/sharedui.service";
import {Configuration} from "@shared/models/configuration";
import {ApplicationIds} from "@shared/constants/common-field.constants";

@Injectable({
  providedIn: 'root'
})
export class SupportAppService extends APlatformAppService {
  constructor(public injector: Injector, public sharedUIService: SharedUIService) {
    super(injector);
    this.platformLogoModel = {
      url: 'https://orbitaxservices.com/orbitax-assets/images/logos/orbitax-help-support-logo.svg',
      width: '230px',
      height: '20px',
      wrapperClass: 'particle-application-logo-hide-when-menu-appear'
    };
  }
  getToolbarShortcutItems(): any[] {
    let toolbarShortcutItems = [
      {
        'title': 'Users',
        'type': 'nav-item',
        'icon': 'fa-user-friends',
        'displayTxt': 'Users',
        'url': 'users',
        'featureId': 'Support-Ticket',
        'key': 'platform-users',
        'licenseFreeAction': 'hidden',
        'metaData': {
          'itemDropdownClass': 'dropdown-contact',
          'itemTopBarClass': 'platform-contacts'
        },
        'hideDisplay' : false,
        'showTitle' : true
      },
      {
        'type': 'nav-item',
        'icon'      : 'fa-regular fa-book',
        'displayTxt': 'Help Center',
        'key': 'platform-help-center',
        'title': 'Help Center',
        'navigate': () => {
          const url = Configuration.getHelpCenterURL();
          window.open(url, '_blank');
        },
        'hideDisplay' : false,
        'showTitle' : true
      },
      // {
      //   'type': 'nav-item',
      //   'icon': 'xbot',
      //   'displayTxt': 'XatBot (AI)',
      //   'key': 'xatbot',
      //   'componentName': 'XatBotNavBarItemComponent',
      //   'title': 'XatBot (AI)',
      //   'featureId': 'XatBotMenu',
      //   'licenseFreeAction': 'hidden',
      //   'navigate': () => {
      //     const xatbotUrl = Configuration.getAbsoluteUrl('xatbot');
      //     window.open(xatbotUrl, '_blank');
      //   },
      //   'metaData': {
      //     'itemDropdownClass': 'dropdown-xatbot',
      //     'itemTopBarClass': 'xatbot'
      //   }
      // },
    ];

    if (Configuration.getConfig('DisableXatBot')) {
      toolbarShortcutItems = toolbarShortcutItems.filter(shortcutItem => shortcutItem.key !== 'xatbot');
    }

    return toolbarShortcutItems;
  }
  getLogoAsStyle() {
    const logoStyle = super.getLogoAsStyle();
    logoStyle['background-position'] = 'center center';
    return logoStyle;
  }
  hasSpotlightSearchToolbar() {
    return false;
  }
  isEnabled(): boolean {
    const isEnabled = Configuration.ApplicationId === ApplicationIds.Support;
    if (isEnabled) {
      this.sharedUIService.setData('sidebarFoldedStatus', true);
      this.sharedUIService.setData('hideLeftMenuBar', true);
    }
    return isEnabled;
  }
  hasProjectToolbar() {
    return false;
  }
  closeMenuBar() {
    this.itpDesktopService.cefSharpPost('menu-bar', 'closed');
    this.sidebarService.setFoldingStatus('navbar', true);
    this.sidebarService.lockSidebar('navbar');
    this.sharedUIService.setData('sidebarFoldedStatus', true);
  }
  solutionMenuAction() {
    //
  }
  hasMenuItem(): boolean {
    return false;
  }
}
